<template>
  <styledSearchBlock class="mob-search-block">
    <input
      v-model="search"
      type="text"
      class="text-input"
      :placeholder="$t('common__search_placeholder')"
    />

    <div class="mob-search__close" @click="clickSearch">
      <mob-search-close-svg :fill="'#B4B5B8'" />
    </div>
  </styledSearchBlock>
</template>

<script>
import MobSearchCloseSvg from '@/components/svg/MobSearchClose';
import { mapActions } from 'vuex';

//TODO: Decompose all styled components;
import styled from 'vue-styled-components';

const styledSearchBlock = styled('div', {})`
  input {
    font-family: var(--font_family);
  }
  &:hover {
    svg path {
      fill: var(--primary);
    }
  }
`;

export default {
  data() {
    return {
      search: '',
    };
  },

  watch: {
    search(nVal) {
      this.handleSearch(nVal);
    },
  },

  methods: {
    ...mapActions(['handleSearch']),
    clickSearch() {
      this.search = null;
      this.$bus.$emit('searchClick', false);
    },
  },

  components: { MobSearchCloseSvg, styledSearchBlock },
};
</script>
